import React from "react";

function IotTechnology() {
  return (
    <div className="leverage-bg mt-5 mb-5">
      <div className="container">
        <div className="row justify-content-center align-items-center ">
          <div className="col-lg-10 col-md-12 col-sm-12 mt-5 mb-5 ">
            <h1 className="Text-heading text-center " data-aos="fade-up">
              Tech Pinnacles: Bespoke IoT App Catalyst
            </h1>
            <p className="text-center text-detail" data-aos="fade-up">
              Virtual Tech has been working with IoT for the last ten years and
              knows exactly what businesses can achieve with this impeccable
              technology.
            </p>
            <div className="text-center" data-aos="fade-up">
              <button className="btn btn-experts p-3">
                Contact Us To being Your Journey
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default IotTechnology;
